// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zC8X4XWEhcOpoWu0aGRh{display:flex;width:100%;height:100%}.UHp31I2EPkFdYmp_3qyj{flex-direction:column}.QVtj05cstg6a51GSPEBg{flex-direction:row}.H3TtW6faSp6f2MfViKw0>div:first-child{flex:0 1 auto}.H3TtW6faSp6f2MfViKw0>div:last-child{flex:1 1 auto;overflow:hidden;position:relative}._KGJEucUXGOdi571YrJm>div{flex:0 0 50%;min-width:50%;width:50%;overflow:hidden;position:relative}._KGJEucUXGOdi571YrJm .DlOvU_Pht2wXqQxQP9y8{height:100%}.DlOvU_Pht2wXqQxQP9y8{display:flex;flex-direction:column}.DlOvU_Pht2wXqQxQP9y8 .ND0owInEplCGjwGMf80s{position:relative;flex:1}.DlOvU_Pht2wXqQxQP9y8 .ND0owInEplCGjwGMf80s>*{position:absolute;height:100%;width:100%}.DlOvU_Pht2wXqQxQP9y8 .MqCeh0idZj_EK1D8GIXy{display:flex}.DlOvU_Pht2wXqQxQP9y8 .MqCeh0idZj_EK1D8GIXy>*{flex:0 0 50%;min-width:50%;flex:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rootStyle": "zC8X4XWEhcOpoWu0aGRh",
	"rootStyleColumn": "UHp31I2EPkFdYmp_3qyj",
	"rootStyleRow": "QVtj05cstg6a51GSPEBg",
	"rootLayout": "H3TtW6faSp6f2MfViKw0",
	"landscapeLayout": "_KGJEucUXGOdi571YrJm",
	"uiBlocks": "DlOvU_Pht2wXqQxQP9y8",
	"grow": "ND0owInEplCGjwGMf80s",
	"tabletTopRow": "MqCeh0idZj_EK1D8GIXy"
};
export default ___CSS_LOADER_EXPORT___;
